var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 16 14",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 14.999993v-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 12-1.5-1.5-1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 14.9999999h2.2499999c.3978584 0 .7794528-.1578906 1.0607811-.4392189s.4392189-.6629227.4392189-1.0607811v-6.7949999c0-.82841168-.6715882-1.49996272-1.5-1.5h-4.8532499c-.24839783-.0000091-.48067109-.12302686-.62025-.3285l-1.05375-1.54875c-.13958086-.20498886-.37150152-.32775006-.6195-.32775006h-3.35325006c-.39785822 0-.77945269.15789071-1.06078099.43921901s-.43921901.66292277-.43921901 1.06078099v8.99999996c0 .3978584.15789071.7794528.43921901 1.0607811s.66292277.4392189 1.06078099.4392189h2.25000006"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0e4e7eaad093615805a98ddddeccf89e.svg";
export { ForwardRef as ReactComponent };